
import React, { useState, useRef } from "react";
import { Button, Divider, Tooltip } from "antd";
import { DownOutlined, PlayCircleOutlined } from "@ant-design/icons";
import "./landing-page-mobile.style.less";
import MobileNavBar from "./MobileNavBar";
import { withRouter } from "react-router-dom";
import ReactSnapScroll from "react-snap-scroll";
import VideoModalMobile from "../VideoPlayer/VideoPlayerMobile/VideoPlayerMobile";
import MenuDropdown from "./MenuDropdown";

const LandingPageMobile = (props) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const snapRef = useRef();

  const moveToTop = () => {

    snapRef.current.state.index = 0;
    setIndex(0);
    snapRef.current.state.direction = "reverse";
    if (menuVisible) {
      setMenuVisible(false);
    }
  };

  const moveTo = (i) => {
    if (i > index) {
      snapRef.current.state.index = i;
      setIndex(i);
      snapRef.current.state.direction = "forward";
    }
    else if (i < index) {
      snapRef.current.state.index = i;
      setIndex(i);
      snapRef.current.state.direction = "reverse";
    }
    setMenuVisible(false);
  };

  const handleSeeVideo = () => {
    setShowVideoModal(true);
  };

  const getSnapScrollChildren = () => {
    var snapScrollChildren = [
      /* Mobile Landing Page Top Section */
      <div>
        <div id="landing-page-mobile-top-section" className="landing-page-mobile-top-section-wrapper">
          <img src={require('../../assets/images/Landing-Page-Mobile/SolarFlow.png')} className="solar-flow-logo" />
          <span className="landing-page-mobile-top-section-header">
            Automate, Digitise, and Standardise your Solar Plant Installation Process
          </span>
          <div className="landing-page-mobile-secondary-heading-wrapper">
            <span className="landing-page-mobile-secondary-heading1">
              A dedicated tool built for the renewable
            </span>
            <span className="landing-page-mobile-secondary-heading2">
              energy industry to help EPC companies
            </span>
            <span className="landing-page-mobile-secondary-heading3">
              execute projects better, faster, and
            </span>
            <span className="landing-page-mobile-secondary-heading4">
              more easily.
            </span>
          </div>
          <div className="first-section-buttons-wrapper">
            <button className="scroll-down-btn" onClick={() => moveTo(1)}>
              Scroll Down
              <DownOutlined />
              <DownOutlined style={{ marginTop: '-10px'}} />
            </button>
            <Button className="see-how-it-works-btn" onClick={handleSeeVideo}>
              See how it works <PlayCircleOutlined />
            </Button>
            {showVideoModal && (
              <VideoModalMobile
                visible={showVideoModal}
                setVisible={setShowVideoModal}
                videoURL="https://safearth-static.s3.ap-south-1.amazonaws.com/explainer_subbed.mp4"
              />
            )}
          </div>
        </div>
        <img src={require('../../assets/images/Landing-Page-Mobile/Flow Illustartion.png')} className="top-section-flow-illustration-image" />
        <div style={{ background: '#7fb0f6', height: '165px' }}></div>  
      </div>,
      /* SolarFlow Platform Features Section */
      <div id="solarflow-platform-features" className="solarflow-platform-features-wrapper">
        <span className="solarflow-platform-features-header">
          SolarFlow Platform Features
        </span>
        <div className="solarflow-platform-features-container">
          <img src={require('../../assets/images/Landing-Page/Checkmark.png')} className="checkmark-image"/>
          <p className="platform-feature-text">Smart Gantt Chart monitoring every aspect of your project</p>
          <img src={require('../../assets/images/Landing-Page/Checkmark.png')} className="checkmark-image"/>
          <p className="platform-feature-text">Automated report generations</p>
          <img src={require('../../assets/images/Landing-Page/Checkmark.png')} className="checkmark-image"/>
          <p className="platform-feature-text">Automated performance tracking</p>
          <img src={require('../../assets/images/Landing-Page/Checkmark.png')} className="checkmark-image"/>
          <p className="platform-feature-text">Standardize and customize workflows</p>
          <img src={require('../../assets/images/Landing-Page/Checkmark.png')} className="checkmark-image"/>
          <p className="platform-feature-text">Automate customer updations</p>
          <img src={require('../../assets/images/Landing-Page/Checkmark.png')} className="checkmark-image"/>
          <p className="platform-feature-text">Cloud-Based secure storage & data back up</p>
        </div>
      </div>,
      /* Standardize Processes Section */
      <div id='standardize-processes' className="standardize-processes-wrapper">
        <img src={require('../../assets/images/Landing-Page-Mobile/Standardize Process.png')} className="standardize-process-image" />
        <div className="standardize-processes-header">
          Standardize Processes
        </div>
        <div className="standardize-processes-subtext-1">
          Customize the Platform to incorporate your standard operating procedures
        </div>
        <div className="standardize-processes-subtext-2">
          The SafEarth Platform allows any user to customize the installation process based on their own Standard Operating Procedures. Our tools ensure and monitor that all your projects are now following the same processes. You can create as many different workflows as you need.
        </div>
        <img src={require('../../assets/images/Landing-Page-Mobile/Flow Illustration 2.png')} className="simplify-communication-flow-illustration-image" />
      </div>,
      /* Simplify Communication Section */
      <div>
        <div className="simplify-communication-wrapper">
          <div className="simplify-communication-header">
            Simplify Communication
          </div>
          <div className="simplify-communication-subtext-1">
            Bring All Stakeholders on one Platform
          </div>
          <div className="simplify-communication-subtext-2">
            The SafEarth Platform brings all stakeholders of the project, your own team, manufacturers, sub-contractors, and most importantly the Customer on one common platform. This ensures that everyone is updated about what is happening on the project and communications gets simplified without any additional efforts.
          </div>
          <img src={require('../../assets/images/Landing-Page-Mobile/Simplify Communication.png')} className="simplify-communication-image" />
        </div>
      </div>,
      /* Automate Section */
      <div style={{ marginTop: '-195px'}}>
        <img src={require('../../assets/images/Landing-Page-Mobile/Automate.png')} className="automate-image-1" />
        {/* <img src={require('../../assets/images/Landing-Page-Mobile/Automate Image 2.png')} className="automate-image-2" /> */}
        
        <img src={require('../../assets/images/Landing-Page-Mobile/Automate-background-1.png')} className="automate-flow-illustration-image-1" />
        <img src={require('../../assets/images/Landing-Page-Mobile/Automate-background-2.png')} className="automate-flow-illustration-image-2" />
        
        <div className="automate-wrapper">
          <p className="automate-header">
            Automate Automate Automate
          </p>
          <p className="automate-subtext-1">
            Automate a number of routine activities
          </p>
          <p className="automate-subtext-2">
            The Platform allows our users to automate a number of activities thereby saving precious time and ensuring that these can happen without any errors. Generate customized reports, before, during, and after your projects. These reports can also be automatically shared with external stakeholders.
          </p>
        </div>
      </div>,
      /* Performance Tracking and Benchmarking Section */
      <div>
        <div className="performance-wrapper">
          <div className="performance-header">
            Performance Tracking and Benchmarking
          </div>
          <div className="performance-subtext-1">
            Track performance of your team and process to improve them
          </div>
          <div className="performance-subtext-2">
            The SafEarth Platform captures a large amount of data and tracks the performance of various team members and subcontractors throughout the project cycle. This allows the decision-makers to make data-driven decisions and improve the performance of both the team and the process itself.
          </div>
        </div>
        <img src={require('../../assets/images/Landing-Page-Mobile/Performance Tracking and Benchmarking.png')} className="performance-tracking-image" />
      </div>,
      /* Mobile Footer Section */
      <div className="mobile-footer-wrapper">
        <img src={require('../../assets/images/Landing-Page-Mobile/App now availale.png')} className="SolarFlow-Mobile-App-image" />
        <img src={require('../../assets/images/Landing-Page-Mobile/Now available on Play Store & App Store.png')} className="Now-available-on-Play-Store-App-Store" />
        <div className="mobile-footer-icons-wrapper">
          <div style={{ display: 'flex', justifyContent: 'center'}}>
            <img
              src={require('../../assets/images/Landing-Page-Mobile/Google_playstore.png')}
              className="google-play-store"
              onClick={() => window.open("https://play.google.com/store/apps/details?id=in.safearth.solarflow", "_blank")}
            />
            <img
              src={require('../../assets/images/Landing-Page-Mobile/Appstore.png')}
              className="apple-app-store"
              onClick={() => window.open("https://apps.apple.com/us/app/solarflow-safearth/id1594860090", "_blank")}
            />
          </div>
          <div className="mobile-footer-icons-subtext">
            Now available on Play Store & App Store
          </div>
          <div className="mobile-request-demo-container">
          <div className="mobile-request-demo-header">
            Join the SafEarth platform today.
          </div>
            <Button type="primary" className="mobile-request-demo-btn" onClick={props.requestDemoAction}>Request a Demo</Button>
          </div>
        </div>
      </div>
    ];

    return snapScrollChildren;
  };

  return (
    <div className="landing-page-mobile-wrapper">
      <MobileNavBar moveToTop={moveToTop} />
      
      <div style={{ height: "100vh", width: "100%" }}>
        <ReactSnapScroll
          transition="move-top-bottom"
          indexChanged={setIndex}
          start={index}
          ref={snapRef}
        >
          {getSnapScrollChildren().map(child => child)}
        </ReactSnapScroll>
      </div>

      {/* Floating Button */}
      <Tooltip
        color="#000"
        placement="left"
        zIndex="8"
        title={
          <Button
            style={{ background: "#000", color: "#fff", border: "none", fontSize: "18px", marginBottom: "5px", fontWeight: 300,zIndex: '8' }}
            onClick={props.requestDemoAction}
          >
            Request a Demo
          </Button>
        }
        overlayStyle={{ boxShadow: "0 auto auto 0 rgba(0, 0, 0, 0.16)" }}
        overlayInnerStyle={{ backgroundColor: '#fff', borderRadius: "5px"}}
        trigger="click"
      >
        <Button className="mobile-request-demo-floating-btn">
          <img src={require("../../assets/images/Landing-Page/Request a demo.png")} />
        </Button>
      </Tooltip>
    </div>
  );
};

export default withRouter(LandingPageMobile);
